/**
 *  ==========================================================================
 * @tencent/eyao-request-web-sdk@1.0.8 (c) 2021 Tencent Application Monitor.
 * Author daveleeli.
 * Last Release Time Fri Jun 11 2021 11:54:37 GMT+0800 (GMT+08:00).
 * Released under the MIT License.
 * ==========================================================================
 **/
import e from"@tencent/eyao-request-core";export{default,getConfig,request,storeRequest}from"@tencent/eyao-request-core";import t from"axios";e({http:t.create(),platform:1});
